import { apiClient } from '@/lib/api.ts'

export function getSapPriceLists(tenantId: string) {
  return apiClient.get('/sap/price-lists', { headers: { 'x-tenant-id': tenantId } })
}

export function getSapManufacturers(tenantId: string) {
  return apiClient.get('/sap/manufacturers', { headers: { 'x-tenant-id': tenantId } })
}
